module.exports = __webpack_public_path__ + "img/badge_toduba.5caad40e.jpg";